var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.319,
    height: 108.297,
    viewBox: "0 0 113.319 108.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send_2_",
    "data-name": "send (2)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5238",
    "data-name": "Path 5238",
    d: "M136.182,333.555l34.157,21.535-3.682-26.254-9.522-12.406-16.09,4.562Z",
    transform: "translate(-88.069 -246.793)",
    fill: "#0092e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5239",
    "data-name": "Path 5239",
    d: "M110.8,43.218a3.49,3.49,0,0,1,1.234,6.053L94.26,63.8,54.068,49.995,0,11.013Z",
    transform: "translate(0 -11.013)",
    fill: "#83deff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5240",
    "data-name": "Path 5240",
    d: "M263.159,80.65l-26.477,21.64-13.774,11.259a3.489,3.489,0,0,1-5.609-1.918l-23.2-100.619,53.134,39.622Z",
    transform: "translate(-194.094 -11.013)",
    fill: "#83deff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5241",
    "data-name": "Path 5241",
    d: "M83.594,11.013,152.659,80.65l13.2,38.66,11.99-55.51Z",
    transform: "translate(-83.594 -11.013)",
    fill: "#00b4fd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3f8407407030ba3174bc3d42ab93ce08.svg";
export { ForwardRef as ReactComponent };